import { useEffect, useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { api, type TenantSummary } from '../api';
import { useAuth } from '../auth';

export function Shell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tenants, setTenants] = useState<TenantSummary[]>([]);

  useEffect(() => {
    api.get<TenantSummary[]>('/api/tenants').then(setTenants).catch(() => setTenants([]));
  }, []);

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <span className="dot" />
          <span>
            IAM Testbench
            <small>SAML · OAuth · PingAccess</small>
          </span>
        </div>

        <nav className="nav">
          <div className="nav-label">Console</div>
          <NavLink to="/admin" end>Tenants</NavLink>
          {user?.role === 'super_admin' && <NavLink to="/admin/users">Admin users</NavLink>}
        </nav>

        {tenants.length > 0 && (
          <nav className="nav">
            <div className="nav-label">Your tenants</div>
            {tenants.map((t) => (
              <NavLink key={t.id} to={`/admin/tenants/${t.id}`}>
                <span>{t.name}</span>
                <span className="faint small">{t.counts.saml + t.counts.oidc + t.counts.ping}</span>
              </NavLink>
            ))}
          </nav>
        )}
      </aside>

      <div className="main">
        <header className="topbar">
          <div className="small dim">{user?.email}</div>
          <div className="row">
            <span className="badge proto">{user?.role === 'super_admin' ? 'super admin' : 'tenant admin'}</span>
            <button className="ghost" onClick={() => logout().then(() => navigate('/login'))}>Sign out</button>
          </div>
        </header>
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
